/* Inches | cm toggle (DESIGN.md §9 row 67). The unit lives on
   html[data-bettino-unit] and in localStorage, so every toggle on the page
   (the Size Guide page, the PDP drawer) shows the same choice. The attribute
   itself is set by the inline script in snippets/bettino-unit-toggle.liquid
   before first paint; this script only syncs aria-pressed and handles
   clicks. Storage is in try/catch: private windows and blocked site data throw. */

(() => {
  if (window.bettinoSizeUnits) return;
  window.bettinoSizeUnits = true;

  const KEY = 'bettino-size-unit';
  const root = document.documentElement;

  const syncPressed = () => {
    const unit = root.getAttribute('data-bettino-unit') === 'cm' ? 'cm' : 'in';
    document.querySelectorAll('[data-unit-button]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.unitButton === unit));
    });
  };

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    // The drawer's switch track flips the unit; the labels either side set it.
    const button = target && target.closest('[data-unit-button], [data-unit-switch]');
    if (!button) return;

    const current = root.getAttribute('data-bettino-unit') === 'cm' ? 'cm' : 'in';
    const unit = button.hasAttribute('data-unit-switch')
      ? current === 'cm'
        ? 'in'
        : 'cm'
      : button.dataset.unitButton === 'cm'
        ? 'cm'
        : 'in';
    if (current === unit) return;

    root.setAttribute('data-bettino-unit', unit);
    try {
      localStorage.setItem(KEY, unit);
    } catch (e) {
      /* the choice still applies for this visit */
    }
    syncPressed();

    // Announce on the toggle that was used, not on every copy of it.
    const group = button.closest('.bettino-units');
    const status = group && group.querySelector('[data-unit-status]');
    if (status) status.textContent = group.dataset[unit === 'cm' ? 'statusCm' : 'statusIn'] || '';
  });

  syncPressed();
})();
